import { IMagazine, IProduct, IResellerModifiedUnion } from 'src/@interfaces'
import { Api } from './api'

export type GetProductsBySkusParams = {
  skus: string[]
  isGenericUser: boolean
  reseller?: IResellerModifiedUnion
  magazine?: IMagazine
}

export function getProductsBySkusService(params: GetProductsBySkusParams) {
  const { skus, isGenericUser, magazine, reseller } = params

  return Api.post<{ products: IProduct[] }>(`/product/`, {
    catalog_slug: !isGenericUser ? reseller?.catalogSlug : undefined,
    state: isGenericUser && magazine ? magazine.cycle.state : reseller?.addressHomeState,
    skus,
  })
}
